<template>
    <div class="loginContent">
        <el-form :rules="rules" ref="ruleForm" :model="ruleForm">
            <el-form-item prop="tel">
                <span class="iconfont iconicon_dl_shouji"></span>
                <el-input v-model="ruleForm.tel" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code" v-if="loginType === 'code'">
                <span class="iconfont iconicon_dl_yanzm"></span>
                <el-input v-model="ruleForm.code" placeholder="请输入验证码" autocomplete="new-password" @keyup.enter.native="login"></el-input>
                <span class="sendCode" v-show="time === 0" @click="sendCode">发送验证码</span>
                <span class="sendCode" v-show="time > 0">{{time}}</span>
            </el-form-item>
            <el-form-item prop="pwd" v-if="loginType === 'pwd'">
                <span class="iconfont iconicon_dl_mima"></span>
                <el-input v-model="ruleForm.pwd" placeholder="请输入密码" type="password" autocomplete="new-password" show-password @keyup.enter.native="login"></el-input>
            </el-form-item>
        </el-form>
        <!-- <NoCaptcha :id="4" ref="NoCaptcha1" style="width:100%;" @result="(r) => nocaptchaParams = r" /> -->
        <div class="forgetPwd">
            <span @click="forgetPwd">忘记密码</span>
        </div>
        <el-button type="primary" @click="login" :disabled="!canLogin" :loading="logining">登录</el-button>
    </div>
</template>
<script>
import queryString from "query-string";
import { telType } from './verification'
// import NoCaptcha from './NoCaptcha'
import { login, getAuthCode } from '../../axios/user'
export default {
    components: {
        // NoCaptcha
    },
    props: {
        loginType: String,
        link: String
    },
    data () {
        var varifacationTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!telType.test(this.ruleForm.tel)) {
                callback(new Error('手机号码格式错误!'))
            } else {
                callback()
            }
        }
        return {
            ruleForm: {
                tel: '',
                code: '',
                pwd: ''
            },
            logining:false,
            time: 0,
            reduceTime: null,
            // nocaptchaParams: null,
            rules: {
                tel: [
                    { validator: varifacationTel, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 4, max: 4, message: '验证码格式不正确', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 8, message: '密码最少为8位', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        forgetPwd () {
            this.$emit('changeLoginType', '找回密码', 'findPwd')
        },
        sendCode () {
            getAuthCode(this.ruleForm.tel, 4).then(({data}) => {
                if (data.success) {
                    this.$message({
                        message: '发送成功',
                        type: 'success'
                    })
                    this.time = 60
                    this.reduceTime = setInterval(() => {
                        this.time -= 1
                        if (this.time === 0) {
                            clearInterval(this.reduceTime)
                        }
                    }, 1000)
                }
            }).catch(() => {
            })
        },
        login () {
            if (!this.canLogin) {
                return
            }
            let params = {}
            // let that = this
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.logining = true;
                 if (this.loginType === 'pwd') {
                params = {
                    loginType: 0,
                    phone: this.ruleForm.tel,
                    password: this.$store.state.jsEnc.encrypt(`${this.ruleForm.pwd},${Date.now()}`),
                    // ...this.nocaptchaParams,
                    // afsToken:this.nocaptchaParams.token
                }
                 } else if (this.loginType === 'code') {
                params = {
                    loginType: 1,
                    phone: this.ruleForm.tel,
                    authCode: this.ruleForm.code,
                    // ...this.nocaptchaParams,
                    //  afsToken:this.nocaptchaParams.token,
                }
                 }
                 login(params).then(({data}) => {
                if (data.success) {
                    this.$cookies.set('token', data.data.token)
                    const urlObj = queryString.parseUrl(window.location.href)
                    if (urlObj.query.redirect_url) {
                        urlObj.url = urlObj.query.redirect_url
                        urlObj.query.ssoToken = data.data.token
                        delete urlObj.query.redirect_url
                        delete urlObj.query.type
                        window.location.href = queryString.stringifyUrl(urlObj)
                    } else {
                        // 没配置跳转链接的情况下，默认跳转会诊的个人中心
                        urlObj.url = 'https://www.imabot.com.cn/home/me/'
                        urlObj.query.ssoToken = data.data.token
                        delete urlObj.query.redirect_url
                        delete urlObj.query.type
                        window.location.href = queryString.stringifyUrl(urlObj)
                    }
                }
                }).finally(()=>{
                    this.logining = false;
                })
            }else {
              return false;
            }
            })
        },
        // resetNoCaptcha () {
        //     this.nocaptchaParams = null
        //     this.$refs.NoCaptcha1.reset()
        // }
    },
    computed: {
        canLogin () {
            if (this.loginType === 'code') {
                // return (!!(telType.test(this.ruleForm.tel)) && !!(this.ruleForm.code.length === 4) && !!this.nocaptchaParams)
                return (!!(telType.test(this.ruleForm.tel)) && !!(this.ruleForm.code.length === 4))
            } else {
                // return (!!(telType.test(this.ruleForm.tel)) && !!(this.ruleForm.pwd.length > 7) && !!this.nocaptchaParams)
                return (!!(telType.test(this.ruleForm.tel)) && !!(this.ruleForm.pwd.length > 7))
            }
        }
    },
    beforeDestroy () {
        clearInterval(this.reduceTime)
    },
    watch: {
        loginType () {
            // if (this.loginType !== 'code' && this.loginType !== 'pwd') {
                // this.resetNoCaptcha()
            // }
        }
    }
}
</script>
<style scoped lang="scss">
.loginContent {
    padding-top: 30px;
    .el-form-item {
        margin-bottom: 20px;

        .iconfont {
            position: absolute;
            left: 12px;
            top: 14px;
            font-size: 18px;
            line-height: 18px;
            color: #ccc;
            z-index: 1;
        }

        .sendCode:hover {
            color: #0263BB;
        }

        .sendCode {
            position: absolute;
            top: 13px;
            right: 0;
            width: 98px;
            height: 20px;
            display: flex;
            justify-content: center;
            line-height: 20px;
            font-size: 14px;
            color: #999999;
            border-left: 1px solid #E6E6E6;
            cursor: pointer;
        }
    }

    .forgetPwd {
        padding-top: 20px;
        text-align: left;

        span {
            font-size: 14px;
            line-height: 14px;
            color: #999999;
            cursor: pointer;
        }

        span:hover {
            color: #0263BB;
        }
    }

    button {
        width: 100%;
        height: 46px;
        margin-top: 16px;
        background: #0263BB;
        border-color: #0263BB;
    }
}
</style>
